
      window.REACT_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
    